import { render } from "./DocumentValidation.vue?vue&type=template&id=eae3798c"
import script from "./DocumentValidation.vue?vue&type=script&lang=js"
export * from "./DocumentValidation.vue?vue&type=script&lang=js"

import "./DocumentValidation.vue?vue&type=style&index=0&id=eae3798c&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__